import { apiClient } from '../index'
import { CancelableRequestProducer } from '../common/types'

export interface IntercomUserHashResponse {
  hash: string
}

// The endpoint returns the HMAC hash as { hash: string } in the response body.
// Base URL comes from REACT_APP_INTERCOM_API_URL (e.g. http://localhost:3000/v2).
export const fetchIntercomUserHash = (email: string): CancelableRequestProducer<IntercomUserHashResponse> => {
  return apiClient.get<IntercomUserHashResponse>('v3/intercom/hash', {
    params: { email },
  })
}
